/** Account menu: who is signed in, settings, sign out. */
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { LogOut, Settings, ShieldCheck, UserRound } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useAuth } from '@/auth/AuthProvider'

const itemClass =
  'flex w-full cursor-pointer items-center gap-2 rounded px-2 py-2 text-sm outline-none ' +
  'data-[highlighted]:bg-surface data-[highlighted]:text-text'

export function UserMenu() {
  const { t } = useTranslation()
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  if (!user) return null

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        aria-label={t('nav.account')}
        className="flex h-11 w-11 items-center justify-center rounded-md text-text-muted hover:bg-surface-raised hover:text-text"
      >
        <UserRound size={18} aria-hidden />
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={6}
          className="z-50 min-w-[14rem] rounded-md border border-border bg-surface-raised p-1 shadow-[var(--shadow-md)]"
        >
          <div className="px-2 py-1.5">
            <p className="truncate text-sm font-medium">{user.display_name || user.username}</p>
            <p className="truncate text-xs text-text-muted">{user.email}</p>
          </div>
          <DropdownMenu.Separator className="my-1 h-px bg-border" />

          <DropdownMenu.Item className={itemClass} onSelect={() => navigate('/settings')}>
            <Settings size={14} aria-hidden />
            {t('nav.settings')}
          </DropdownMenu.Item>

          {user.system_role === 'sysadmin' && (
            <DropdownMenu.Item className={itemClass} onSelect={() => navigate('/admin')}>
              <ShieldCheck size={14} aria-hidden />
              {t('nav.admin')}
            </DropdownMenu.Item>
          )}

          <DropdownMenu.Separator className="my-1 h-px bg-border" />
          <DropdownMenu.Item
            className={itemClass}
            onSelect={async () => {
              await logout()
              navigate('/login', { replace: true })
            }}
          >
            <LogOut size={14} aria-hidden />
            {t('nav.sign_out')}
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
